<section class="debug--preview">
  <div class="col--right">

    @if (positiveCards.length) {
      <!-- Factores positivos -->
      <section class="gauge-section">
        <header class="section-header">
          <h3>{{ previewContent()?.positiveFactorsTitle }}</h3>
          <span class="badge" aria-hidden="true">
            <img src="assets/icons-reports/positivo.svg" alt="" aria-hidden="true">
          </span>
        </header>

        <div class="gauge-grid">
          @for (c of positiveCards; track trackByGauge($index, c)) {
            <app-gauge-card
              [title]="c.title"
              [percent]="c.percent"
              [scoreLabel]="c.scoreLabel"
              [level]="c.level">
            </app-gauge-card>
          }
        </div>
      </section>
    }

    @if (negativeCards.length) {
      <!-- Factores negativos -->
      <section class="gauge-section">
        <header class="section-header">
          <h3>{{ previewContent()?.negativeFactorsTitle }}</h3>
          <span class="badge" aria-hidden="true">
            <img src="assets/icons-reports/negativo.svg" alt="" aria-hidden="true">
          </span>
        </header>

        <div class="gauge-grid">
          @for (c of negativeCards; track trackByGauge($index, c)) {
            <app-gauge-card
              [title]="c.title"
              [percent]="c.percent"
              [scoreLabel]="c.scoreLabel"
              [level]="c.level">
            </app-gauge-card>
          }
        </div>
      </section>
    }

    @if (!positiveCards.length && !negativeCards.length) {
      <app-empty-state [message]="previewContent()?.emptyStateMessage ?? ''"></app-empty-state>
    }

  </div>
</section>

